module.exports = __webpack_public_path__ + "static/media/job_modal_info.5e68e088.svg";